<div class="row page-title">
  <app-back-button [title]="localizationConstants.ADMIN_BACK_BUTTON_TITLE"></app-back-button>
  <span>{{ localizationConstants.PENDING_USERS_PAGE_TITLE | translate }}</span>
</div>
<div
  *ngIf="isLoading"
  class="row center">
  <div class="col">
    <app-loading-icon
      class="u-color--light"
      size="2x"></app-loading-icon>
  </div>
</div>
<div
  class="row"
  [hidden]="!dataSource.data">
  <div class="col">
    <div class="col-12 col-sm-6 col-md-3 u-mb--medium">
      <form class="c-search-form--full">
        <div class="c-input-group">
          <input
            type="text"
            name="search"
            id="input-search"
            [(ngModel)]="dataSource.filter"
            class="c-input c-input--beta"
            placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
            required />
          <input
            *ngIf="dataSource.filter"
            id="users-search-clear"
            (click)="dataSource.filter = ''"
            class="c-button c-button--search c-close-search c-button--search--sm"
            value="Clear" />
          <input
            *ngIf="!dataSource.filter"
            id="users-search"
            type="submit"
            class="c-button c-button--search c-button--search--sm"
            value="Search" />
        </div>
      </form>
    </div>
    <div class="u-scroll--horizontal">
      <div class="col">
        <table
          mat-table
          matSort
          [dataSource]="dataSource"
          matSortActive="requestDate"
          matSortDirection="desc"
          class="c-table">
          <ng-container
            *ngFor="let col of columns"
            [matColumnDef]="col.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="c-table__column-title">
              {{ col.title | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let row">
              <ng-container [ngSwitch]="col.key">
                <span *ngSwitchCase="'country'">
                  <span [class.c-badge]="!(row.userId > 0)">{{ row.country }}</span>
                </span>
                <span *ngSwitchCase="'firstName'">
                  {{ row.firstName | titlecase }} {{ row.lastName | titlecase }}
                </span>
                <span *ngSwitchCase="'email'">
                  {{ row.email }}
                </span>
                <span *ngSwitchCase="'company'">
                  {{ row.company }}
                </span>
                <span *ngSwitchCase="'requestDate'">
                  {{ row.requestDate | date }}
                </span>
                <span *ngSwitchCase="'address'">
                  <pre>{{ row.address }}</pre>
                </span>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="action1">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="c-table__column-title"></th>
            <td
              mat-cell
              *matCellDef="let row"
              class="action">
              <button
                *ngIf="!row.userId"
                [routerLink]="[routeNameConstants.ADMIN_USERS_NEW, row.id]"
                type="button"
                class="button--sm button-primary button-block"
                [disabled]="row.pending">
                {{ "button.create" | translate }}
              </button>
              <button
                *ngIf="row.userId"
                [routerLink]="[routeNameConstants.ADMIN_USERS, row.userId]"
                type="button"
                class="button--sm button-secondary button-block"
                [disabled]="row.pending">
                {{ "button.edit" | translate }}
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="action2">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="c-table__column-title"></th>
            <td
              mat-cell
              *matCellDef="let row"
              class="action">
              <button
                (click)="onRemoveUser(row)"
                type="button"
                class="button--sm button-secondary button-block"
                [disabled]="row.pending">
                <app-loading-icon *ngIf="row.pending"></app-loading-icon>
                <span *ngIf="!row.pending">{{ "button.delete" | translate }}</span>
              </button>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="columnKeysAll"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: columnKeysAll"
            class="c-table__row"></tr>
        </table>
      </div>
    </div>
    <div class="c-pagination--desktop">
      <div class="col-12">
        <mat-paginator
          [showFirstLastButtons]="true"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
